import { isEmpty } from "lodash";

import { ecmCategoryOrder } from "utils/parametric";

/**
 * Mirrors backend `getUpgradesToApply` (validation) in generateSnapCombos.js for combo counting only.
 */
const getUpgradesToApplyForValidation = (ecmInputMap = {}) => {
    const userSpecifiedUpgrades = ecmCategoryOrder.reduce((cache, ecmCatId) => {
        if (Object.keys(ecmInputMap).includes(ecmCatId)) {
            const categoryEcms = ecmInputMap[ecmCatId] || {};
            const selectedEcmArray = Object.keys(categoryEcms)
                .filter((key) => categoryEcms[key])
                .filter((key) => {
                    if (key === "None") return true;
                    return categoryEcms[key].active && !categoryEcms[key].firstBatchId;
                })
                .sort();

            return {
                ...cache,
                [ecmCatId]: isEmpty(selectedEcmArray) ? ["None"] : selectedEcmArray,
            };
        }
        return cache;
    }, {});

    const heatingCoolingUpgrades = (userSpecifiedUpgrades?.heatingCooling || []).filter((upgrade) => upgrade !== "None");

    if (heatingCoolingUpgrades.length > 0) {
        userSpecifiedUpgrades.spaceHeating = ["None"];
        userSpecifiedUpgrades.spaceCooling = ["None"];
        userSpecifiedUpgrades.secondaryHeating = ["None"];
    }

    return userSpecifiedUpgrades;
};

/**
 * Count of validation single-upgrade combos (matches `generateSnapSingleCombos` without materializing the full cartesian product).
 * Total = 1 (all "None") + sum over categories of (number of non-None options).
 */
export const getCommunityValidationComboCount = (ecmInputMap = {}) => {
    const upgradesToApply = getUpgradesToApplyForValidation(ecmInputMap);
    const types = Object.keys(upgradesToApply);
    if (types.length === 0) return 0;

    let count = 1;
    types.forEach((type) => {
        const opts = upgradesToApply[type] || ["None"];
        const nonNoneCount = opts.filter((v) => v !== "None").length;
        count += nonNoneCount;
    });

    return count;
};

/** UI / product constraint: validation batch must be within [min, max] inclusive. */
export const COMMUNITY_VALIDATION_COMBO_MIN = 1;
export const COMMUNITY_VALIDATION_COMBO_MAX = 250;
